import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P200Dashboard = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_dashboard`), body, authorization)
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P200GetDataList = async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_request_list`), body, authorization)
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


